/* eslint-disable max-len */
import { DatePipe, NgClass, NgFor, NgIf } from "@angular/common";
import { Component, ElementRef, HostListener, OnInit, viewChild } from "@angular/core";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";
import { UserBio } from "src/app/models/UserBio";
import { ChatService } from "src/app/service/chat.service";
import { EmployeeService } from "src/app/shared/services/employee.service";
import * as uuid from "uuid";
import { SmallBioComponent } from "../../routes/my-profile/bio/small-bio/small-bio.component";
import { CommonGraphicComponent } from "../common-graphic/common-graphic.component";
@Component({
    selector: "app-common-chatbot",
    templateUrl: "./common-chatbot.component.html",
    styleUrls: ["./common-chatbot.component.scss"],
    imports: [
        MatIcon,
        CommonGraphicComponent,
        NgFor,
        NgClass,
        ExtendedModule,
        NgIf,
        SmallBioComponent,
        FormsModule,
        DatePipe,
    ]
})
export class CommonChatbotComponent implements OnInit {
  readonly chatBody = viewChild<ElementRef>("chatBody");
  isChatOpen = false;
  isBotThinking = false;
  userInput = "";
  user: UserBio;
  messages = [];
  sessionId;

  constructor(
    private eRef: ElementRef,
    private employeeService: EmployeeService,
    private chatService: ChatService
  ) {}

  ngOnInit(): void {
    this.employeeService.getBio().subscribe((user) => {
      this.user = user;
    });
    this.sessionId = uuid.v4();
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    if (this.messages.length === 0 && !this.isBotThinking) {
      this.initialChatResponse();
    }
  }

  sendMessage() {
    const userInput = this.userInput.trim();
    if (userInput) {
      const message = {
        messageId: uuid.v4(),
        sessionId: this.sessionId,
        timestamp: new Date().toISOString(),
        body: userInput,
        employeeId: "S113733",
      };
      this.messages.push({
        text: this.userInput,
        time: new Date(),
        user: "user",
        messageId: message.messageId,
      });
      this.scrollToBottom();
      this.userInput = "";
      this.isBotThinking = true;
      this.chatService.sendMessage(message).subscribe((response) => {
        this.isBotThinking = false;
        this.messages.push({
          text: response.body,
          time: new Date(),
          user: "bot",
          messageId: response.messageId,
          sessionId: this.sessionId,
        });
        this.scrollToBottom();
      });
    }
  }

  submitFeedback(message, helpful) {
    if (message.helpful === helpful) {
      helpful = null;
    }
    message.helpful = helpful;
    this.chatService.submitFeedback(message, helpful).subscribe((response) => {
      message.helpful = helpful;
    });
  }

  initialChatResponse() {
    this.isBotThinking = true;
    setTimeout(() => {
      this.isBotThinking = false;
      this.messages.push({
        text: `
      Welcome to the me@slalom chatbot! <br/><br/>
 
      Please note that the chatbot is still in development. At this time, please use this tool for testing purposes only. Please verify all answers before making any decisions based on chatbot responses. <br/><br/>
       
      You can ask me about: <br/><br/>
       
      - me@slalom Career Framework <br/>
      - PTO Balance <br/>
      - Slalom Guide to Life <br/>
      `,
        time: new Date(),
        user: "bot",
      });
    }, 1000);
  }

  scrollToBottom() {
    setTimeout(() => {
      const chatBody = this.chatBody().nativeElement;
      chatBody.scrollTop = chatBody.scrollHeight;
    }, 500);
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && this.isChatOpen) {
      this.isChatOpen = false;
    }
  }

  @HostListener("document:keydown.enter", ["$event"])
  handleEnter(event: KeyboardEvent) {
    this.sendMessage();
  }
}
